import { render } from "./ValuesBlocks.vue?vue&type=template&id=6bee46ef"
import script from "./ValuesBlocks.vue?vue&type=script&lang=js"
export * from "./ValuesBlocks.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__